module.exports = __webpack_public_path__ + "img/bingo_ball-73.6c18ff9b.png";